var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      title: _vm.$t("label_essweb_punchManage_list_wifi_dialog_newTitle"),
      width: 680,
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { md: "3" } },
                      [
                        _c("v-switch", {
                          attrs: {
                            color: "primary",
                            label: _vm.Data.status
                              ? _vm.$t(
                                  "label_essweb_punchManage_list_wifi_dialog_activeLabel"
                                )
                              : "",
                          },
                          model: {
                            value: _vm.Data.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "status", $$v)
                            },
                            expression: "Data.status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            TrigerInit: _vm.show,
                            bindData: _vm.Data.criteria_wifi_name,
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_nameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.criteria_wifi_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            TrigerInit: _vm.show,
                            maxlength: "500",
                            bindData: _vm.Data.criteria_wifi_description,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.criteria_wifi_description = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_punchManage_list_wifi_dialog_siteLabel",
                            items: _vm.siteList,
                            "item-text": "site_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.Data.site_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "site_uuid", $$v)
                            },
                            expression: "Data.site_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: "80",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_pssIdLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.ssid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "ssid", $$v)
                            },
                            expression: "Data.ssid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            defaultTime: _vm.Data.effective_utc_datetime,
                            type: "date",
                            max: _vm.Data.expired_utc_datetime,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_effectiveStartDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.Data.effective_utc_datetime = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            defaultTime: _vm.Data.expired_utc_datetime,
                            min: _vm.Data.effective_utc_datetime,
                            label: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_expiredEndDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.Data.expired_utc_datetime = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_punchManage_list_wifi_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            "single-line": "",
                            maxlength: "500",
                            filled: "",
                            placeholder: _vm.$t(
                              "label_essweb_punchManage_list_wifi_dialog_remarkLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "remarks", $$v)
                            },
                            expression: "Data.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.toNew, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }